import { render, staticRenderFns } from "./FieldsList.vue?vue&type=template&id=684204ef&scoped=true"
import script from "./FieldsList.vue?vue&type=script&lang=js"
export * from "./FieldsList.vue?vue&type=script&lang=js"
import style0 from "./FieldsList.vue?vue&type=style&index=0&id=684204ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684204ef",
  null
  
)

export default component.exports